import { useParams } from "react-router-dom";
import ExtendService from "./ExtendService";

export const ShowService = () => {
  const { id } = useParams();

  return <ExtendService row={{ id, onUpdate: () => {}, onDelete: () => {} }} />;
};
